<div class="flex flex-col basis-full">
    <div class="flex flex-row display">
      <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
      <div class="flex flex-col items-center mt-16">
        <div class="fw-700 fs-24 failed-title mt-16">{{title}}</div>
        <div class="flex justify-end w-100-percent mt-16 mb-8">
            <mat-slide-toggle [ngClass]="[disabledToggle ? 'disabled' : '']" class="h-30 mr-20 toggle items-center" [checked]="buildInstallSpec" (change)="encryptData($event)">{{ (buildInstallSpec ? 'ADD_VERSION.ENCODE' : 'ADD_VERSION.DECODE') | transloco}}</mat-slide-toggle>
            <button class="h-30 error-copy-class" [ngClass]="[copy ? 'copied': 'copy']" (click)="copyText(description)">
                <span *ngIf="!copy" class="fs-12 fw-400 item flex items-center">
                <mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERROR_DIALOG.COPY' | transloco }}
                </span>
                <span *ngIf="copy" class="fs-12 fw-400 item flex items-center copied-text">
                <mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERROR_DIALOG.COPIED' | transloco }}
                </span>
            </button>
        </div>
        <mat-divider></mat-divider>
        <div class="overflow-class w-100-percent p-16" >
          <div>{{description}}</div>
        </div>
      </div>
    </div>
    <div *ngIf="error" class="mt-10 error-color">{{error}}</div>
    <div class="flex flex-row justify-center items-center mb-20 mt-36">
      <button class="white mr-20 report-letter-spacing" type="button" (click)="matdialogRef.close()"> {{ 'ERROR_DIALOG.BACK' | transloco }} </button>
    </div>
  </div>
  